import React, { useEffect, useState, useRef } from "react";
import { Button } from "@material-ui/core";

import { toast } from "react-hot-toast";
import http from "../services/httpService";

import { useHistory, useRouteMatch } from "react-router-dom";
import { TextField, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CloudUploadSharpIcon from "@mui/icons-material/CloudUploadSharp";
import AddLinkIcon from "@mui/icons-material/AddLink";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

function Uploadexcel() {
  let history = useHistory();

  const [sheetTitle, setsheetTitle] = useState({ title: "" });
  const [disableTitlefield, setdisableTitlefield] = useState(true);
  const [checked, setChecked] = useState(false);
  const [showLoader, setsetshowLoader] = useState(false);
  const [showIdfield, setsetshowIdfield] = useState(false);
  const [sheetId, setsheetId] = useState("");
  const [submitsheetId, setSubmitsheetId] = useState("");
  const [sheetLink, setsheetLink] = useState("");

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
    navigator.clipboard.writeText(sheetId);
  };
  const handleTooltipClose2 = () => {
    setOpen2(false);
  };

  const handleTooltipOpen2 = () => {
    setOpen2(true);
    navigator.clipboard.writeText(sheetLink);
  };

  const handlesheetTitleChange = (e) => {
    setsheetTitle({ title: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    setdisableTitlefield(!e.target.checked);
    setsheetTitle({ title: "" });
  };

  const handleSheetInput = (e) => {
    setSubmitsheetId(e.target.value);
  };

  const requestSheet = () => {
    setsetshowLoader(true);
    setsetshowIdfield(false);
    http
      .post("bulkupload", sheetTitle)
      .then((response) => {
        setsetshowLoader(true);

        if ((response.status = 201)) {
          setsheetId(response.data.spreadsheet_id);
          // let spreadsheetId = sheetId.toString();
          setsheetLink(
            "https://docs.google.com/spreadsheets/d/" +
              response.data.spreadsheet_id
          );
          setsetshowLoader(false);
          setsetshowIdfield(true);
        } else if ((response.status = 500)) {
          toast.error("Failed to Create Spreadsheet");
          setsetshowLoader(false);
          setsetshowIdfield(false);
        }
      })
      .catch((error) => {
        toast.error("Failed to Create Spreadsheet");
      });
  };

  const submitSheet = () => {
    toast.success("Sync Started");
    http
      .get("bulkupload?" + "spreadsheet_id=" + submitsheetId)
      .then((response) => {
        if ((response.status = 200)) {
          console.log("Sync Started");
        } else if ((response.status = 500)) {
          toast.error("Failed to Start Sync");
        }
      })
      .catch((error) => {
        toast.error("Failed to Start Sync");
      });
  };

  return (
    <>
      <Paper elevation={3} style={{ padding: "20px", marginBottom: 30 }}>
        <h2 style={{ marginBottom: "30px" }}>Generate Sheet </h2>
        <div style={{ display: "flex", marginBottom: 20 }}>
          <Checkbox
            value={checked}
            {...label}
            onChange={handleCheckboxChange}
          />
          <TextField
            label="Title"
            placeholder="Enter"
            onChange={handlesheetTitleChange}
            variant="outlined"
            disabled={disableTitlefield}
            value={sheetTitle.title}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Button
            startIcon={<AddLinkIcon />}
            variant="outlined"
            color="primary"
            onClick={requestSheet}
            style={{ marginLeft: 15 }}
          >
            Generate
          </Button>
        </div>

        {showIdfield ? (
          <>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                label="Sheet Id"
                // onChange={handlesheetTitleChange}
                variant="outlined"
                disabled
                value={sheetId}
                sx={{ width: "600px" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <ClickAwayListener onClickAway={handleTooltipClose}>
                <div>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="Copied"
                  >
                    <IconButton
                      color="primary"
                      size="large"
                      onClick={handleTooltipOpen}
                      style={{ marginLeft: 10 }}
                    >
                      <ContentCopyOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </ClickAwayListener>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                label="Sheet Link"
                fullwidth
                // onChange={handlesheetTitleChange}
                variant="outlined"
                disabled
                value={sheetLink}
                sx={{ width: "900px" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <ClickAwayListener onClickAway={handleTooltipClose2}>
                <div>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose2}
                    open={open2}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="Copied"
                  >
                    <IconButton
                      color="primary"
                      size="large"
                      onClick={handleTooltipOpen2}
                      style={{ marginLeft: 10 }}
                    >
                      <ContentCopyOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </ClickAwayListener>
            </div>
          </>
        ) : null}
        <div>{showLoader ? <LinearProgress color="inherit" /> : ""}</div>
      </Paper>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <Paper elevation={3} style={{ padding: "20px" }}>
        <h2 style={{ marginBottom: "30px" }}>Sync New Prospects Sheet</h2>
        <div style={{ display: "flex", marginBottom: 20 }}>
          <TextField
            label="Sheet Id"
            variant="outlined"
            placeholder="Enter"
            sx={{ width: "600px" }}
            onChange={handleSheetInput}
            value={submitsheetId}
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          <Button
            startIcon={<CloudUploadSharpIcon />}
            variant="outlined"
            color="primary"
            style={{ marginLeft: 15 }}
            onClick={submitSheet}
          >
            Start Sync
          </Button>
        </div>
        <Typography variant="subtitle2">
          Please follow the below instructions:
        </Typography>
        <Typography variant="body2" style={{ lineHeight: "25px" }}>
          1. If you are not able to access the spreadsheet through the link
          above then you haven't registered with your google account on Savart.
          Login to your registered account and try with the link we have emailed
          you.
          <br />
          2. Check the Google Sheet for the sync status.
          <br />
          3. If you find any cells in <span style={{ color: "red" }}>
            Red
          </span>{" "}
          then the cell data exists already.
          <br />
          4. If the table cells turn{" "}
          <span style={{ color: "green" }}>Green</span> then it signifies
          successful sync.
          <br />
        </Typography>
      </Paper>
    </>
  );
}

export default Uploadexcel;
